import { faSignOut } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FC } from 'react'

import { DropdownMenuItem } from 'components/DropdownMenu'
import { useLoginProvider } from 'hooks/useLoginProvider'
import { useTranslation } from 'services/i18n'
import { clearSensitiveCookies } from 'utils/cookie'

export const Logout: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_menu',
  })

  const { redirectToLogout } = useLoginProvider()

  return (
    <DropdownMenuItem
      className="h-10"
      onClick={() => {
        clearSensitiveCookies()
        redirectToLogout()
      }}
    >
      <FontAwesomeIcon icon={faSignOut} className="mr-2 w-4" />
      <span>{t('logout')}</span>
    </DropdownMenuItem>
  )
}
